// extracted by mini-css-extract-plugin
module.exports = {"screen":"screen_screen_2DIadKj","iframe":"screen_iframe_3RJq3u5","overlay":"screen_overlay_1Khj9T7"};